import { useQuery } from '@tanstack/react-query'
import { useAtomValue } from 'jotai'
import { localeAtom } from 'src/stores/locale'
import { getBaseLanguageCode } from 'src/utils/tack'
import { orpcClient } from './client'
import { tackTrendingOptions } from './generated/@tanstack/react-query.gen'
import type { TackTrendingResponse } from './generated/types.gen'

export type TrendingTackItem = TackTrendingResponse['data'][number]

export function useTrendingTacks(
  page: number,
  pageSize = 100,
  sort?: 'trending' | 'weekly' | 'daily',
) {
  // Subscribe to `localeAtom` so the hook re-runs when the user switches
  // languages — `lang` flows into the react-query key, so a non-reactive
  // snapshot would keep returning stale `displayName` results.
  const locale = useAtomValue(localeAtom)
  const lang = getBaseLanguageCode(locale)
  return useQuery({
    ...tackTrendingOptions({
      client: orpcClient,
      query: { page, pageSize, sort, lang },
    }),
    staleTime: 30_000,
    throwOnError: true,
  })
}
